import {DependencyList, useLayoutEffect} from 'react';

import {StringOrNumber} from '@macmillanplatform/ui-core/types';
import {isObject} from '@macmillanplatform/ui-core/utils';

import {browserHistory} from '@/shared/utils';

const UNWANTED_PARAMS: string[] = [];

type UrlParamValue = StringOrNumber | UrlParams;

interface UrlParams {
  [key: string]: UrlParamValue;
}

interface UrlParam {
  name: string;
  value: StringOrNumber;
}

const getInitialUrlParams = (params: UrlParams): UrlParam[] => {
  return Object.entries(params).reduce<UrlParam[]>((acc, [name, value]) => {
    if (UNWANTED_PARAMS.includes(name)) return acc;
    if (isObject(value)) return [...acc, ...getInitialUrlParams(value)];
    return [...acc, {name, value}];
  }, []);
};

interface UseInitUrlParamsProps {
  dataFromUrl: UrlParams;
  dependencies?: DependencyList;
}

const useInitUrlParams = ({
  dataFromUrl,
  dependencies = [],
}: UseInitUrlParamsProps): void => {
  useLayoutEffect(() => {
    const params = getInitialUrlParams(dataFromUrl);

    browserHistory.setParametersValues(params);
  }, dependencies);
};

export default useInitUrlParams;
